// ===== SLIDESHOW PAUSE BUTTON =====
(function() {
  function initPauseButton() {
    document.querySelectorAll('.slideshow__pause-button').forEach(function(btn) {
      if (btn._pauseInit) return;
      btn._pauseInit = true;

      var section = btn.closest('section');
      if (!section) return;

      var slideshowComponent = section.querySelector('slide-show');

      btn.addEventListener('click', function() {
        var isPaused = btn.getAttribute('aria-pressed') === 'true';

        if (isPaused) {
          // Resume autoplay
          if (slideshowComponent) slideshowComponent.startPlayer();
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', 'Pause slideshow');
          btn.querySelector('.slideshow__pause-icon').hidden = false;
          btn.querySelector('.slideshow__play-icon').hidden = true;
        } else {
          // Pause autoplay
          if (slideshowComponent) slideshowComponent.pausePlayer();
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', 'Play slideshow');
          btn.querySelector('.slideshow__pause-icon').hidden = true;
          btn.querySelector('.slideshow__play-icon').hidden = false;
        }
      });
    });
  }

  initPauseButton();
  document.addEventListener('DOMContentLoaded', initPauseButton);
})();
